import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginService } from '../service';

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const login = async (email: string, password: string): Promise<boolean> => {
    setLoading(true);
    setError(null);
    
    try {
      await loginService(email, password);
      setLoading(false);
      navigate('/deliveries', { replace: true });
      return true;
    } catch (err) {
      setError('Error al iniciar sesión. Verifica tus credenciales.');
      setLoading(false);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('alubike_auth');
    navigate('/auth/login', { replace: true });
  };

  return {
    login,
    logout,
    loading,
    error
  };
}; 